import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./youtube-embed.module.scss";

export interface IYoutubeEmbed {
  embedId: string;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const YoutubeEmbed = (props: IYoutubeEmbed) => {
  return (
    <div className={cx(styles.youtube_embed, props.className)} style={props.style} id={props.htmlId}>
      <iframe
        width="853"
        height="480"
        src={`https://www.youtube.com/embed/${props.embedId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  );
};

YoutubeEmbed.defaultProps = {};
